
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/legacy/get_trade_fee",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/legacy/get_trade_fee/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/legacy/get_trade_fee"])
      });
    }
  